var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "pageHeader",
      staticClass: "c-page-header",
      attrs: { id: "pageHeader" }
    },
    [
      _c(
        "div",
        { staticClass: "c-page-header__wrapper", attrs: { role: "banner" } },
        [
          _c("div", { staticClass: "o-width-limiter" }, [
            _c(
              "div",
              { staticClass: "c-page-header__inner" },
              [
                _vm._t("mkb-logo"),
                _vm._v(" "),
                _c(
                  "nav",
                  {
                    staticClass: "c-page-header__nav t-display--md",
                    attrs: { "aria-label": "Huvudnavigering" }
                  },
                  [
                    _c(
                      "ul",
                      { staticClass: "c-page-header__nav__list" },
                      _vm._l(_vm.shortCutLinks, function(link, index) {
                        return _c(
                          "li",
                          {
                            key: index,
                            class: [
                              {
                                "c-page-header__nav__item--active":
                                  _vm.activeItemId === index && _vm.showSubMenu
                              },
                              "c-page-header__nav__item"
                            ]
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "c-page-header__nav__button",
                                attrs: {
                                  id: "item-" + index,
                                  "aria-controls":
                                    _vm.activeItemId === index
                                      ? "content-" + index
                                      : null,
                                  "aria-expanded":
                                    _vm.activeItemId === index &&
                                    _vm.showSubMenu
                                },
                                on: {
                                  click: function(e) {
                                    return _vm.handleClick(e, index)
                                  }
                                }
                              },
                              [
                                _c("v-icon", {
                                  attrs: {
                                    name: link.icon,
                                    size: "m",
                                    "css-modifiers": ""
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "c-page-header__nav__button-text"
                                  },
                                  [_vm._v(_vm._s(link.name))]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "c-page-header__button-wrapper" },
                  [
                    _c("v-search-pane", {
                      attrs: {
                        url: _vm.searchPageUrl,
                        apiUrl: _vm.searchApiUrl,
                        searchButtonText: _vm.searchButtonText,
                        searchPlaceholder: _vm.searchPlaceholder,
                        performSearchText: _vm.performSearchText,
                        className: "c-page-header__search",
                        isActive: _vm.showSearchPane
                      },
                      on: {
                        "update:isActive": function($event) {
                          _vm.showSearchPane = $event
                        },
                        "update:is-active": function($event) {
                          _vm.showSearchPane = $event
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "a",
                        {
                          staticClass:
                            "c-page-header__button--round c-page-header__my-pages",
                          attrs: { href: _vm.myPagesUrl }
                        },
                        [
                          _c("v-icon", {
                            attrs: { name: "icon-user", size: "s" }
                          }),
                          _vm._v("\n\t\t\t\t\t\t\t‍"),
                          _c("span", { staticClass: "t-visually-hidden" }, [
                            _vm._v("Mina sidor")
                          ])
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("v-mobile-menu", {
                      attrs: {
                        links: _vm.links,
                        isActive: _vm.showMobileMenu,
                        menuButtonText: _vm.menuButtonText,
                        closeMenuButtonText: _vm.closeMenuButtonText,
                        className: "c-page-header__mobile-menu"
                      },
                      on: {
                        "update:isActive": function($event) {
                          _vm.showMobileMenu = $event
                        },
                        "update:is-active": function($event) {
                          _vm.showMobileMenu = $event
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              2
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("Transition", { attrs: { name: "fade" } }, [
        _vm.showSubMenu
          ? _c(
              "div",
              {
                ref: "subnav",
                staticClass: "c-page-header__subnav",
                attrs: {
                  id: "content-" + _vm.activeItemId,
                  "aria-hidden": _vm.showSubMenu ? "false" : "true"
                }
              },
              [
                _c(
                  "ul",
                  {
                    staticClass:
                      "o-width-limiter o-width-limiter--main c-page-header__subnav__list"
                  },
                  _vm._l(_vm.links[_vm.activeItemId].pages, function(
                    sublink,
                    index
                  ) {
                    return _vm.links
                      ? _c(
                          "li",
                          {
                            key: index,
                            staticClass: "c-page-header__subnav__item"
                          },
                          [
                            _c(
                              "a",
                              {
                                class: [
                                  {
                                    "c-page-header__subnav__link--active":
                                      sublink.selected
                                  },
                                  "c-page-header__subnav__link"
                                ],
                                attrs: {
                                  href: sublink.url,
                                  "aria-current": sublink.selected
                                    ? "true"
                                    : "false"
                                }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(sublink.name) +
                                    "\n\t\t\t\t\t"
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  }),
                  0
                )
              ]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }